import { exportTimesheetExcel } from '../../exportTimesheet';
import { fetchYearTimesheets } from '../../services/timesheets';
import { notify } from '../../store/feedback';
import { clientsToFlatProjects } from '../../utils/phases';

export default function timesheetsExportHandlers(deps, api) {
  const {
    adminUsers,
    profile,
    resolveTimesheetUserId,
    session,
    setExporting,
    appState,
    timesheetUserId,
    timesheetMonth,
  } = deps;

  async function handleExportYear() {
    setExporting(true);
    try {
      const userId = resolveTimesheetUserId(timesheetUserId);
      const exportYear = parseInt(timesheetMonth.slice(0, 4), 10); // exporte l'année actuellement affichée dans le calendrier
      let personName;
      if (userId === session.user.id) personName = profile?.nom || 'Moi';
      else {
        const u = adminUsers.find((p) => p.id === userId);
        personName = u?.nom || u?.email || 'Collaborateur';
      }
      const { data, error } = await fetchYearTimesheets(exportYear, userId);
      if (error) throw error;
      await exportTimesheetExcel({
        year: exportYear,
        personName,
        timesheets: data || [],
        projets: clientsToFlatProjects(appState.clients),
      });
    } catch (e) {
      notify("Erreur lors de l'export : " + (e.message || e));
    } finally {
      setExporting(false);
    }
  }

  return { handleExportYear };
}
